import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  createModelFailed,
  createModelRequested,
  createModelSucceeded,
  deleteModelFailed,
  deleteModelRequested,
  deleteModelSucceeded,
  updateModelFailed,
  updateModelRequested,
  updateModelSucceeded,
} from '../../../actions';
import api from '../../../api';

export function* createModelRequest(data) {
  yield put(createModelRequested(data));

  try {
    const { item } = yield call(request, api.createModel, data);

    const action = createModelSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = createModelFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* updateModelRequest(id, data) {
  yield put(updateModelRequested(id, data));

  try {
    const { item } = yield call(request, api.updateModel, id, data);

    const action = updateModelSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = updateModelFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* deleteModelRequest(id) {
  yield put(deleteModelRequested(id));

  try {
    const { item } = yield call(request, api.deleteModel, id);

    const action = deleteModelSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = deleteModelFailed(id, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
